module.exports = __webpack_public_path__ + "static/media/handshake-alt.2d75a9e7.svg";